<mat-card *ngIf="form && answerControl.length > 0">
  <mat-card-header>
    <mat-card-title>
      <h1>
        <span class="form-name">{{form.form}}</span> |
        {{name}}
      </h1>
    </mat-card-title>
    <mat-card-subtitle>
      <h3>Year - <span class="form-name">{{form.year}}</span></h3>
      <h3>Questions - <span class="form-name">{{form.questions}}</span></h3>
      <h3>Unanswered - <span class="form-name">{{form.unanswered}}</span></h3>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group dynamicHeight>
      <mat-tab  *ngFor="let category of categoriesWithQuestions" [label]="category.description">
        <div class="tab-body" *ngFor="let question of questions; index as i">
          <div *ngIf="category.id === question.category.id">
            <form class="form-search-bar" [formGroup]="answerForm" autocomplete="off">
              <div formArrayName="answers">
                <h2><span>{{question.description}}</span><span
                  matTooltip="{{question.mandatory ? 'Mandatory question' : ''}}"
                  class="required-asterisk">{{question.mandatory ? ' *' : ''}}</span></h2>

                <p>{{question.comment}}</p>

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i" *ngIf="question.answerType === 'TEXT'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <input matInput type="text" formControlName="answer">
                  <mat-error *ngIf="answerControl.at(i).get('answer')?.hasError('maxlength')">
                    {{'The maximum length is ' + answerControl.at(i).get('answer')?.getError('maxlength').requiredLength}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i" *ngIf="question.answerType === 'NUMBER'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <input matInput type="number" formControlName="answer">
                  <mat-error *ngIf="answerControl.at(i).get('answer')?.hasError('min')">
                    {{'The minimum value is ' + answerControl.at(i).get('answer')?.getError('min').min}}
                  </mat-error>
                  <mat-error *ngIf="answerControl.at(i).get('answer')?.hasError('max')">
                    {{'The maximum value is ' + answerControl.at(i).get('answer')?.getError('max').max}}
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="filter-item" appearance="fill" [formGroupName]="i" *ngIf="question.answerType === 'BOOLEAN'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <mat-select class="readonly-block" formControlName="answer">
                    <mat-option [value]="">-</mat-option>
                    <mat-option [value]="'true'">Yes</mat-option>
                    <mat-option [value]="'false'">No</mat-option>
                  </mat-select>
                </mat-form-field>


<!--                <p *ngIf="question.answerType === 'LIST'">{{availableAnswers[i] | json}}</p>-->
<!--                <p>{{answerControl.controls[i].value.answer}}</p>-->

                <mat-form-field appearance="fill" class="filter-item" [formGroupName]="i"
                                *ngIf="question.answerType === 'LIST'">
                  <mat-label>{{'intelligence-reporting.questions.answer' |translate}}</mat-label>
                  <mat-select formControlName="answer" [multiple]="question.multiSelect">
                    <mat-option *ngFor="let a of availableAnswers[i]" [value]="a">{{a}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="filter-item" appearance="fill" [formGroupName]="i">
                  <mat-label>{{'intelligence-reporting.questions.sharing-level' | translate}}</mat-label>
                  <mat-select formControlName="sharingLevel">
                    <mat-option *ngFor="let sl of sharingLevel" [value]="sl.value">{{sl.description}}</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="filter-item" appearance="fill" [formGroupName]="i" *ngIf="question.mandatory">
                  <mat-label>{{'intelligence-data-entry.reason' | translate}} {{'intelligence-data-entry.unanswered' | translate}}</mat-label>
                  <mat-select formControlName="reasonUnanswered"  (selectionChange)="removeRequired(i, true)">
                    <mat-option [value]="null">-</mat-option>
                    <mat-option *ngFor="let ur of reasonUnanswered" [value]="ur.value">{{ur.description}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </form>
            <mat-divider></mat-divider>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="answer-buttons-container">
      <button mat-raised-button type="button"
              (click)="goBack()">
        <span>Back</span>
      </button>
    </div>
  </mat-card-content>
</mat-card>
